import React, { useEffect, useState } from 'react';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { GoChevronLeft, GoChevronRight } from 'react-icons/go';
import { IoMdNotificationsOutline } from 'react-icons/io';
import { IoSearchSharp } from 'react-icons/io5';
import { TbLogout } from 'react-icons/tb';
import { useDispatch, useSelector } from 'react-redux';
import { LogoIcon, ShortLogoIcon } from '../../../Assets/icons';
import { isMobileViewHook } from '../../../CustomHooks/isMobileViewHook';
import AreYouSureModal from '../../../Modals/AreYouSureModal';
import { logOutRequest } from '../../../Store/authSlice';
import Button from '../../UI/Button';
import classes from './Header.module.css';
import { MobileHeader } from './MobileHeader';
const Header = ({ title = '', isOnBoarding = false, onPrev, onNext }) => {
  const profile = useSelector((state) => state?.authReducer?.profile);
  const [isMobile, setIsMobile] = useState(false);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [showMobileDrawer, setShowMobileDrawer] = useState(false);

  const logoutHandler = () => {
    dispatch(logOutRequest());
  };

  const toggleMobileDrawer = () => {
    setShowMobileDrawer((currentState) => !currentState);
  };

  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
    //call Api for getting profile Information
  }, []);

  return (
    <>
      {isOnBoarding ? (
        // on boarding Header
        <header className={classes.onBoardingHeader}>
          <figure>
            <LogoIcon />
          </figure>
        </header>
      ) : (
        // all header features
        <header className={classes.header}>
          <section className={classes.allFeatureHeader}>
            <span>
              <ShortLogoIcon />
            </span>
            <h2>{title}</h2>
            <ul className={classes.navigateActionsWrapper}>
              <li className={classes.cta}>
                <span
                  onClick={() => {
                    if (typeof onPrev === 'function') onPrev();
                  }}>
                  <GoChevronLeft />
                </span>
              </li>
              <li className={classes.cta}>
                <span
                  onClick={() => {
                    if (typeof onNext === 'function') onNext();
                  }}>
                  <GoChevronRight />
                </span>
              </li>
            </ul>
          </section>
          {/* decide content in mobile view */}
          {!isMobile ? (
            <section className={classes.actionsWrapper}>
              {/* <span className={classes.iconWrapper}>
                <IoSearchSharp color="var(--icon-color)" size={20} />
              </span>
              <span className={classes.iconWrapper}>
                <IoMdNotificationsOutline color="var(--icon-color)" size={20} />
              </span> */}
              <span className={classes.iconWrapper} onClick={() => setShow(true)}>
                <TbLogout color="var(--icon-color)" size={20} />
              </span>
              <span className={classes.profileWrapper}>
                {profile?.profileImage ? (
                  <img className="img-fluid" src={profile?.profileImage} alt="profile" />
                ) : (
                  <span className={classes.fallback}>{profile?.fullName?.slice(0, 1)}</span>
                )}
              </span>
            </section>
          ) : (
            <Button
              className={classes.mobileActionBtn}
              variants="transparent"
              onClick={toggleMobileDrawer}>
              <BsThreeDotsVertical />
            </Button>
          )}
        </header>
      )}
      <AreYouSureModal
        setShow={() => setShow(false)}
        show={show}
        onClick={logoutHandler}
        icon={<TbLogout size={80} />}
        title={'Logout'}
        subTitle={'Are You Sure you want to logout?'}
      />
      <MobileHeader toggleDrawer={toggleMobileDrawer} show={showMobileDrawer} />
    </>
  );
};

export default Header;
